import styled, { css } from "styled-components"
import Div from "../div/div.component"

export const DiscordConversationContainer = styled(Div)`
  position: relative;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: auto;
`

export const BackgroundPhoneImage = styled.img`
  grid-column: 2 / 6;
  z-index: 1;
  width: 100%;
  height: auto;
`

const ConversationContainerStyles = css`
  opacity: 1;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 2;
`

export const RightConversationContainer = styled(Div)`
  ${ConversationContainerStyles};
  top: 11.5%;
  right: -60px;
  grid-column: 4 / 7;
  align-items: center;
  @media only screen and (max-width: 1300px) {
    top: 10%;
  }
  @media only screen and (max-width: 1160px) {
    top: 5%;
  }
`

export const LeftConversationContainer = styled(Div)`
  ${ConversationContainerStyles};
  top: 55%;
  grid-column: 1 / 4;
  @media only screen and (max-width: 1300px) {
    top: 40%;
  }
  /* @media only screen and (max-width: 1160px) {
    top: 35%;
  } */
  /* @media only screen and (max-width: 1070px) {
    top: 25%;
  } */
`

export const ProfileImage = styled.img`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  align-self: ${({ logo }) => (logo ? "flex-end" : "flex-start")};
  z-index: 2;
  margin-right: 20px;
  margin-left: 20px;
`

export const TextContainer = styled(Div)`
  background-color: #1A1A1A;
  color: #eee;
  border-radius: 30px;
  padding: 15px 20px 15px 15px;
  font-size: 18px;
  line-height: 28px;
  margin-top: -12px;
  /* margin-top: ${({ isStudent }) => (isStudent ? "-12px" : "30px")}; */
  border: 2px solid ${({ isStudent }) => (isStudent ? "#FF4CD2" : "#5865F2")};

  @media only screen and (max-width: 1300px) {
    font-size: 17px;
  }
  @media only screen and (max-width: 1160px) {
    font-size: 15px;
  }
`

export const HashContainer = styled(Div)`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: 100px;
  border: none;

  @media only screen and (min-width: 1200px) {
    margin-left: 120px;
  }

  @media only screen and (max-width: 1300px) {
    margin-top: 80px;
  }

  @media only screen and (max-width: 1100px) {
    margin-top: 40px;
  }
`

export const TextHashContainer = styled(TextContainer)`
  white-space: nowrap;
  padding: 10px 18px;
  margin-top: 10px;
  border: 2px solid #373F49;
  border-radius: 15px;
  font-size: 16px;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
`
